import { notification } from 'antd'
import React, { useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import AppService from 'services/AppService'

const VerifyEmail = () => {
    const {token} = useParams()
    const history = useHistory()

    const verifyEmailAddress = async () => {
        try {
            const {message, id} = await AppService.verifyEmailAddress(token);
            notification.success({message})
            history.push(`/app/edit-profile/${id}`);
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        if(token) {
            verifyEmailAddress();
        }
    },[token])

  return (
    <div style={{minHeight: '76vh'}}></div>
  )
}

export default VerifyEmail